// RMSRadioGroup.jsx

import React from 'react';
import {
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormHelperText,
} from '@material-ui/core';
import { Controller, useFormContext } from 'react-hook-form';

const RMSRadioGroup = ({ name, label, options = [], row = true, disabled = false }) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <FormControl component="fieldset" error={!!error} fullWidth>
          <FormLabel component="legend">{label}</FormLabel>

          <RadioGroup
            {...field}
            row={row}
            value={field.value || ''}
            onChange={(e) => field.onChange(e.target.value)}>
            {options.map((option) => (
              <FormControlLabel
                key={option.value}
                value={option.value}
                control={<Radio />}
                label={option.label}
                disabled={disabled || field.disabled}
              />
            ))}
          </RadioGroup>

          <FormHelperText>{error?.message}</FormHelperText>
        </FormControl>
      )}
    />
  );
};

export default RMSRadioGroup;
